import axios from "axios";
import { MenuItem } from "./AyudaModal";
import Swal from "sweetalert2";

export const getAyuda = (
  setState: Function,
  IdMenu: string,
  Opcion: string,
) => {
  const getRolId = () => {
    const roles = localStorage.getItem("Roles");
    if (roles) {
      const rolArray = JSON.parse(roles);
      // Asegúrate de que roles[0] exista y tenga el campo 'Id'
      return rolArray.length > 0 ? rolArray[0].Id : null;
    }
    return null;
  };
  const IdRol = getRolId();
  axios
    .get(process.env.REACT_APP_APPLICATION_ENDPOINT + "/ayuda/lista", {
      params: {
        Opcion: Opcion,
        IdMenu: IdMenu === "0" ? "0" : localStorage.getItem("IdMenuActual") || 0,
        IdRol: IdRol || ""
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken") || "",
      },
    })
    .then(({ data }) => {

      setState(data.data);

    });
};

export const getMenus = (setState: Function) => {
  axios
    .get(process.env.REACT_APP_APPLICATION_LOGIN_BACK + "/api/listas", {
      params: { Tabla: "Menus", ValorCondicion: localStorage.getItem("IdApp") },
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken") || "",
      },
    })
    .then((r) => {

      let menus = r.data.data
      let menusFiltrados = menus.filter((menu: MenuItem) => menu.Path !== "#")
      setState(menusFiltrados);

    });
};

export const createAyuda = async (data: any, handleClose: Function) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_APPLICATION_ENDPOINT}/ayuda/alta`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("jwtToken") || "",
        },
        timeout: 30000 // 30 segundos de timeout
      }
    );

    if (response.data?.success) {
      handleClose();
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: response.data.message || "Pregunta creada correctamente",
        confirmButtonColor: '#15212f',
        confirmButtonText: 'Aceptar'
      });
    } else {
      throw new Error(response.data?.message || "Respuesta inesperada del servidor");
    }
  } catch (error: unknown) {
    console.error("Error en createAyuda:", error);

    let errorMessage = "Error al crear la pregunta";

    if (axios.isAxiosError(error)) {
      errorMessage = error.response?.data?.message || error.message || errorMessage;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    }

    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorMessage,
      confirmButtonColor: '#15212f',
      confirmButtonText: 'Entendido'
    });
  };
}
export const deleteAyuda = async (IdPreguntaFrecuente: string, handleClose: Function) => {

  await axios({
    method: "delete",
    url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/ayuda/delete",
    data: {
      IdPreguntaFrecuente: IdPreguntaFrecuente,
      IdUsuario: localStorage.getItem("IdUsuario") || ""
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("jwtToken") || "",
    },
  })
    .then((r) => {
      handleClose();
      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: "El archivo se ha eliminado exitosamente",
        confirmButtonColor: '#15212f',
        confirmButtonText: 'Aceptar'
      });
    })
    .catch(() => {
      //alertaError();
      Swal.fire({
        confirmButtonColor: "#15212f",
        icon: "error",
        title: "No se pudo editar la autorizacion.",
      });
    });
};


export const saveFile = (
  valueTab: string,
  archivo: { archivo: File; nombreArchivo: string },
  idMenu: string,
  pregunta: string,
  texto: string,
  handleClose: Function
) => {
  const url = new File([archivo.archivo], archivo.nombreArchivo);
  let ruta = "";
  valueTab === "Guías" ? (ruta = "/GUIAS/") : (ruta = "/VIDEOS/TUTORIALES/");
  ruta = (process.env.REACT_APP_DOC_ROUTE || "") + ruta;
  let dataArray = new FormData();
  dataArray.append("ROUTE", `${ruta}`);
  dataArray.append("ADDROUTE", "TRUE");
  dataArray.append("FILE", url); // probar mandar archivo.archivo

  axios
    .post(
      process.env.REACT_APP_APPLICATION_FILES + "SaveFile",
      dataArray,
      {
        headers: {
          Authorization: localStorage.getItem("jwtToken") || "",
        },
      }
    )
    .then(({ data }) => {
      if (valueTab === "Guías") {
        if (data) {
          createAyuda(
            {
              IdMenu: idMenu,
              Pregunta: pregunta,
              Texto: "",
              RutaGuia: data?.RESPONSE.RUTA,
              RutaVideo: "",
              NombreArchivo: archivo.nombreArchivo,
              NombreArchivoServidor: data?.RESPONSE.NOMBREIDENTIFICADOR,
              IdUsuario: localStorage.getItem("IdUsuario"),
            },
            handleClose

          );
        } else {
          Swal.fire({
            confirmButtonColor: "#15212f",
            icon: "error",
            title: "Error al cargar archivo.",
          });
        }
      } else {
        if (data) {
          createAyuda(
            {
              IdMenu: idMenu,
              Pregunta: "",
              Texto: "",
              RutaGuia: "",
              RutaVideo: data?.RESPONSE.RUTA,
              NombreArchivo: archivo.nombreArchivo,
              NombreArchivoServidor: data?.RESPONSE.NOMBREIDENTIFICADOR,
              IdUsuario: localStorage.getItem("IdUsuario"),
            },
            handleClose
          );
        } else {
          Swal.fire({

            icon: "error",
            title: "Error al cargar archivo.",
            confirmButtonColor: '#15212f',
            confirmButtonText: 'Aceptar'
          });
        }
      }
    })
    .catch((e) => {
      Swal.fire({
        confirmButtonColor: "#15212f",
        icon: "error",
        //title: "Error al cargar archivo.",
      });
    });
};

export const getFileByName = async (
  ROUTE: string,
  NOMBRE: string,
  setState: (url: string) => void  // 👈 cambia a solo string
) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_APPLICATION_FILES}GetByName`,
      { ROUTE, NOMBRE },
      {
        headers: {
          Authorization: localStorage.getItem("jwtToken") || "",
        },
      }
    );

    const byteArray = Uint8Array.from(atob(data.RESPONSE.FILE), c => c.charCodeAt(0));
    const blob = new Blob([byteArray], { type: data.RESPONSE.TIPO || "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    setState(url);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Ocurrió un problema al obtener el archivo.",
      confirmButtonColor: "#15212f",
      confirmButtonText: "Aceptar",
    });
  }
};




export const deleteFile = async (ROUTE: string, NOMBRE: string, Id: string, fnc: Function) => {
  await axios
    .post(
      process.env.REACT_APP_APPLICATION_FILES + "DeleteFile",
      {
        ROUTE: ROUTE,
        NOMBRE: NOMBRE,
      },
      {
        headers: {
          Authorization: localStorage.getItem("jwtToken") || "",
        },
      }
    )
    .then((r) => {

      deleteAyuda(Id, fnc)

    })
    .catch((r) => {
      Swal.fire({
        icon: "error",
        title: "Ocurrio un problema al eliminar el archivo.",
        confirmButtonColor: '#15212f',
        confirmButtonText: 'Aceptar'
      });
    });

};